import { Directive, HostBinding, Input } from '@angular/core';

import { toRequiredAriaBoolean } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yPressed]'
})
export class A11yPressedDirective {
  @Input('khA11yPressed') public pressed: boolean | string | null = false;

  @HostBinding('attr.aria-pressed')
  public get ariaPressed(): 'true' | 'false' {
    return toRequiredAriaBoolean(this.pressed);
  }
}
